import React from "react";
import { Sun, Moon } from "lucide-react";

// Reusable Day/Night toggle.
// variant="onDark"  -> sits on the charcoal/dark header (Home TopBar)
// variant="floating" -> standalone glassy pill on top of the canvas (Embed)
export function DayNightToggle({ night, onToggle, theme, variant = "onDark" }) {
  const Icon = night ? Sun : Moon;
  const floating = variant === "floating";
  const label = night ? "Day" : "Night";

  return (
    <button
      type="button"
      data-testid="day-night-toggle"
      onClick={onToggle}
      aria-label={night ? "Switch to day mode" : "Switch to night mode"}
      title={night ? "Switch to day mode" : "Switch to night mode"}
      className="inline-flex items-center gap-2 rounded-[10px] px-3 py-2 text-sm font-display font-semibold uppercase tracking-wide active:scale-[0.98] transition-colors"
      style={
        floating
          ? {
              background: theme.chipBg,
              color: theme.chipText,
              border: `1px solid ${theme.panelBorder}`,
              boxShadow: "var(--shadow-panel)",
              backdropFilter: "blur(10px)",
            }
          : {
              background: "rgba(255,255,255,0.1)",
              color: "#fff",
              border: "1px solid transparent",
            }
      }
    >
      <Icon size={16} color="#FFCE24" />
      <span className="hidden sm:inline" data-testid="day-night-toggle-label">{label}</span>
    </button>
  );
}

export default DayNightToggle;
